import ReactGA from "react-ga4"
import { productDetails } from "../utils/global_variables";

const useAnalyticsEventTracker = (category) => {
    const eventTracker = (action, details = productDetails) => {
      let updatedCategory = `WEB_${category}` // Parshva S : 8/10/24 : Added "WEB_" changes for firebase events tracking for Breeze.
      let updatedAction = `WEB_${action}` // Parshva S : 8/10/24 : Added "WEB_" changes for firebase events tracking for Breeze.
      ReactGA.event({updatedCategory, updatedAction, details});
    }
    return eventTracker;
  }
  export default useAnalyticsEventTracker;
  